import { Component, OnInit } from '@angular/core';

@Component({
	selector: 'recursos',
	templateUrl: './recursos.component.html',
	styleUrls: ['./recursos.component.scss']
})
export class RecursosComponent implements OnInit {

	constructor() {
	}

	ngOnInit() {
	}

}
